// @ts-expect-error no types for ResizeSensor build artifact
window.ResizeSensor = require('theia-sticky-sidebar/dist/ResizeSensor.js');
require('theia-sticky-sidebar');
import $ from 'jquery';
import { Base } from '@gate31/core/src/libs/BaseComponent';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { MindboxApi } from '@gate31/core/src/api/mindboxApi';
import { ProductReviewsDesk } from '../../components/ProductReviewsDesk/ProductReviewsDesk';
import { ProductFormDesk } from '../../components/ProductFormDesk/ProductFormDesk';
import { WarehouseProductDesk } from '../../components/WarehouseProductDesk/WarehouseProductDesk';
import { ProductModalGallerySliderDesk } from '../../components/ProductModalGallerySliderDesk/ProductModalGallerySliderDesk';
import { ProductVideoDesk } from '../../components/ProductVideoDesk/ProductVideoDesk';
import { HeaderWrapperDesk } from '../../components/HeaderWrapperDesk/HeaderWrapperDesk';
import { TableSizeDesk } from '../../components/TableSizeDesk/TableSizeDesk';
import { TableSizeTriggerDesk } from '../../components/TableSizeTriggerDesk/TableSizeTriggerDesk';
import { DolyamiModalDesk } from '../../components/DolyamiModalDesk/DolyamiModalDesk';

class ProductPage extends Base<HTMLElement> {
    static cn = new Base.BuildCn('ProductPage');

    buttonWarehouseAccordion: HTMLElement;
    buttonDolyamiTrigger?: HTMLElement;

    dolyamiModal?: DolyamiModalDesk;
    productForm: ProductFormDesk;
    product: InsalesProduct;
    productWarehouse: WarehouseProductDesk;
    productModalGallerySliderDesk: ProductModalGallerySliderDesk;
    productVideoDesk: ProductVideoDesk;
    tableSizeDesk: TableSizeDesk;

    constructor(node: HTMLElement) {
        super(node);

        this.buttonWarehouseAccordion = document.querySelector('[data-name="warehouse"]') as HTMLElement;
        this.buttonDolyamiTrigger = this.getRoot().querySelector(ProductPage.cn.setElem('dolya').toSelector()) as HTMLElement;

        if (this.buttonDolyamiTrigger) {
            this.dolyamiModal = new DolyamiModalDesk({
                trigger: this.buttonDolyamiTrigger
            });
        }

        this.product = new InsalesProduct(JSON.parse(this.getRoot().getAttribute('data-product') ?? ''));
        this.productForm = new ProductFormDesk({
            node: ProductFormDesk.querySelector<HTMLFormElement>(ProductFormDesk.cn.toSelector()),
            product: this.product
        });
        this.productWarehouse = new WarehouseProductDesk({
            template: 'warehouse-product-desk-template',
            product: this.product,
            trigger: this.buttonWarehouseAccordion
        });
        this.productModalGallerySliderDesk = new ProductModalGallerySliderDesk({
            template: 'product-modal-gallery-slider-desk-template',
            product: this.product,
            headerWrapper: HeaderWrapperDesk.querySelector<HTMLDivElement>(HeaderWrapperDesk.cn.toSelector())
        });

        MindboxApi.productView(this.product.id);

        if (this.product.id && this.product.variants[0].base_price) {
            MindboxApi.addViewed(this.product.id, this.product.variants[0].base_price);
        }

        if (document.querySelector(TableSizeTriggerDesk.cn.toSelector())) {
            this.tableSizeDesk = new TableSizeDesk({
                template: 'table-size-desk-template',
                trigger: TableSizeTriggerDesk.querySelector<HTMLDivElement>(TableSizeTriggerDesk.cn.toSelector()),
                templateData: {
                    local: {
                        title: window.TABLE_SIZE?.LOCAL_TEMPLATE_TABLE_SIZE?.title,
                        content: window.TABLE_SIZE?.LOCAL_TEMPLATE_TABLE_SIZE?.content
                    },
                    global: {
                        title: window.TABLE_SIZE?.GLOBAL_TEMPLATE_TABLE_SIZE?.title,
                        content: window.TABLE_SIZE?.GLOBAL_TEMPLATE_TABLE_SIZE?.content
                    }
                }
            });
        }

        ProductVideoDesk.init();

        $(document).ready(function() {
            // @ts-ignore
            $(ProductPage.cn.setElem('information').toSelector()).theiaStickySidebar({
                additionalMarginTop: 40
            });
        });

        // eslint-disable-next-line
        new ProductReviewsDesk(ProductReviewsDesk.querySelector(ProductReviewsDesk.cn.toSelector()), { product: this.product });
    }
}

// eslint-disable-next-line
new ProductPage(ProductPage.querySelector(ProductPage.cn.toSelector()));
